module.exports = __webpack_public_path__ + "static/media/splash-bar-backing.498f93b8.png";